import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/oscararmstrong/node/ignission/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/ignission/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CTAButton"] */ "/Users/oscararmstrong/node/ignission/src/app/_components/CTAButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oscararmstrong/node/ignission/src/app/_components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/Users/oscararmstrong/node/ignission/src/app/_components/PricingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenshotsSection"] */ "/Users/oscararmstrong/node/ignission/src/app/_components/ScreenshotsSection.tsx");
